import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import HomeIcon from "@mui/icons-material/Home";
import AddCircleOutlineTwoToneIcon from "@mui/icons-material/AddCircleOutlineTwoTone";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import GavelIcon from "@mui/icons-material/Gavel";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ListAltIcon from "@mui/icons-material/ListAlt";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import PolicyIcon from "@mui/icons-material/Policy";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AssignmentTwoToneIcon from "@mui/icons-material/AssignmentTwoTone";
import InsertDriveFileTwoToneIcon from "@mui/icons-material/InsertDriveFileTwoTone";
import ImageIcon from "@mui/icons-material/Image";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import NotificationsIcon from "@mui/icons-material/Notifications";
import InsertPageBreakIcon from "@mui/icons-material/InsertPageBreak";
// css
import "./SideBar.css";

const SideBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  let NavData = [
    {
      neme: "Home",
      link: "/admin/home",
      icon: <HomeIcon className="sidebar__icon" />,
    },
    {
      neme: "Carousel",
      link: "/admin/carousel",
      icon: <ImageIcon className="sidebar__icon" />,
    },
    {
      neme: "CarouselList",
      link: "/admin/carousellist",
      icon: <ImageIcon className="sidebar__icon" />,
    },
    {
      neme: "Add Notification",
      link: "/admin/addnotification",
      icon: <NotificationsActiveIcon className="sidebar__icon" />,
    },
    {
      neme: "Notification list",
      link: "/admin/notificationlist",
      icon: <NotificationsIcon className="sidebar__icon" />,
    },
    // {
    //   neme: " All User",
    //   link: "/admin/user-list",
    //   icon: <PeopleAltIcon className="sidebar__icon" />,
    // },
    {
      neme: "Subject",
      link: "/admin/subject",
      icon: <InsertPageBreakIcon className="sidebar__icon" />,
    },
    {
      neme: " Create User",
      link: "/admin/create-user",
      icon: <PersonAddAltIcon className="sidebar__icon" />,
    },
    {
      neme: " New Bare Act",
      link: "/admin/create-bareact",
      icon: <GavelIcon className="sidebar__icon" />,
    },
    {
      neme: " Bare Act List",
      link: "/admin/bareAct-table",
      icon: <ListAltIcon className="sidebar__icon" />,
    },
    {
      neme: "New Article",
      link: "/admin/create-article",
      icon: <ChatBubbleOutlineIcon className="sidebar__icon" />,
    },
    {
      neme: "Article List",
      link: "/admin/article-table",
      icon: <ListAltIcon className="sidebar__icon" />,
    },
    {
      neme: "New Judgement",
      link: "/admin/create-landmark",
      icon: <BookmarkIcon className="sidebar__icon" />,
    },
    {
      neme: " Judgement List",
      link: "/admin/landmark-table",
      icon: <ListAltIcon className="sidebar__icon" />,
    },
    {
      neme: " New Legal Term",
      link: "/admin/create-legal-term",
      icon: <PolicyIcon className="sidebar__icon" />,
    },
    {
      neme: " Legal Term List",
      link: "/admin/legal-term-table",
      icon: <ListAltIcon className="sidebar__icon" />,
    },
    {
      neme: "  New MCQ",
      link: "/admin/create-mcq",
      icon: <QuestionAnswerIcon className="sidebar__icon" />,
    },
    {
      neme: "  MCQ List",
      link: "/admin/mcq-table",
      icon: <ListAltIcon className="sidebar__icon" />,
    },
    {
      neme: "   New Mock Test",
      link: "/admin/create-mocktest",
      icon: <RecordVoiceOverIcon className="sidebar__icon" />,
    },
    {
      neme: "  Mock Test List",
      link: "/admin/mocktest-table",
      icon: <ListAltIcon className="sidebar__icon" />,
    },
    {
      neme: "   New PYQ",
      link: "/admin/create-pyq",
      icon: <AddCircleOutlineTwoToneIcon className="sidebar__icon" />,
    },
    {
      neme: "  PYQ List",
      link: "/admin/pyq-table",
      icon: <ListAltIcon className="sidebar__icon" />,
    },
    {
      neme: "   New Syllabus",
      link: "/admin/create-syllabus",
      icon: <AddCircleOutlineTwoToneIcon className="sidebar__icon" />,
    },
    {
      neme: "  Syllabus List",
      link: "/admin/syllabus-table",
      icon: <ListAltIcon className="sidebar__icon" />,
    },
    {
      neme: "   New Word",
      link: "/admin/create-dictionary",
      icon: <FiberNewIcon className="sidebar__icon" />,
    },
    {
      neme: "  Dictionary",
      link: "/admin/dictionary-table",
      icon: <MenuBookIcon className="sidebar__icon" />,
    },
    {
      neme: "  New Legal Essay",
      link: "/admin/create-legalessay",
      icon: <AssignmentTwoToneIcon className="sidebar__icon" />,
    },
    {
      neme: "  Legal Essay",
      link: "/admin/legalessay-table",
      icon: <AssignmentIcon className="sidebar__icon" />,
    },
    {
      neme: "  Word OF Day",
      link: "/admin/word-of-day",
      icon: <InsertDriveFileTwoToneIcon className="sidebar__icon" />,
    },
  ];
  return (
    <div className="sidebar">
      <div className="sidebar__wrapper">
        <div className="sidebar__menu">
          <h3 className="sidebar__title">Dashboard</h3>
          <ul
            className="sidebar__list"
            style={{
              overflow: "auto",
              height: "86vh",
            }}
          >
            {NavData?.map((w) => {
              const Tagname = w?.icon;
              const DynamicTag = `${w?.icon}`;

              return (
                <li
                  key={w?.neme}
                  className="sidebar__listItem"
                  onClick={() => navigate(w?.link)}
                  style={{
                    backgroundColor:
                      location.pathname == w?.link ? "#333d82" : "",
                    color: location.pathname == w?.link ? "white" : "",
                  }}
                >
                  {w?.icon}
                  {w?.neme}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
